(function(){
  try {
    // Skip entirely on Checkout/Thank You contexts to avoid interfering
    var isCheckoutCtx = function(){
      try {
        if (window.Shopify && Shopify.Checkout) return true;
        var p = (window.location && window.location.pathname) || '';
        if (/^\/checkout(\/|$)/i.test(p)) return true;
        if (/thank_you/i.test(p)) return true;
        var b = (document.body && (document.body.id || document.body.className)) || '';
        if (String(b).toLowerCase().indexOf('checkout') > -1) return true;
      } catch(e) {}
      return false;
    };
    if (isCheckoutCtx()) return;

    // Skip on contact pages to avoid conflicts with chat/captcha widgets
    var isContactCtx = function(){
      try {
        var p = (window.location && window.location.pathname || '').toLowerCase();
        if (p.indexOf('/pages/contact') === 0) return true;
        if (p.indexOf('/pages/contact-us') === 0) return true;
      } catch(e) {}
      return false;
    };
    if (isContactCtx()) return;

    var isBad = function(v){
      if (v == null) return true;
      var s = String(v).trim();
      if (!s) return true;
      var sl = s.toLowerCase();
      return sl === 'undefined' || sl === 'null' ||
        sl.indexOf('undefined&width=') > -1 || sl.indexOf('undefined?width=') > -1 ||
        sl.indexOf('/undefined&width=') > -1 || sl.indexOf('/undefined?width=') > -1 ||
        sl.indexOf('/products/undefined') > -1 || sl.indexOf('/files/undefined') > -1 ||
        sl.indexOf('products/undefined') > -1 || sl.indexOf('files/undefined') > -1 ||
        sl.indexOf('undefined&width=1') > -1 || sl.indexOf('undefined?width=1') > -1 ||
        sl.indexOf('products/undefined&width=1') > -1 ||
        sl.indexOf('/products/undefined&width=') > -1 || sl.indexOf('/products/undefined?width=') > -1;
    };

    // Early image error listener to catch undefined URLs before they load
    // This catches direct image requests that bypass our interceptors
    if (document.addEventListener) {
      document.addEventListener('error', function(e) {
        try {
          if (e.target && e.target.tagName === 'IMG') {
            var src = e.target.src || e.target.getAttribute('src') || e.target.getAttribute('data-src') || '';
            if (src && (src.indexOf('/products/undefined') > -1 || src.indexOf('undefined&width=') > -1)) {
              // Prevent the image from loading
              e.target.removeAttribute('src');
              e.target.removeAttribute('data-src');
              e.target.style.display = 'none';
              e.target.classList.add('kt-bad-src');
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        } catch(err) {}
      }, true); // Use capture phase to catch early
    }

    // Sanitizer for already-inserted markup (e.g., via innerHTML)
    var purgeBadUrl = function(el){
      try {
        if (!el || el.nodeType !== 1) return;
        var attrs = ['src','srcset','data-src','data-bg','href'];
        for (var i=0;i<attrs.length;i++){
          var a = attrs[i];
          if (el.hasAttribute && el.hasAttribute(a)){
            var v = el.getAttribute(a);
            if (isBad(v)) {
              el.removeAttribute(a);
              // Don't add kt-bad-src to links - it breaks SEO crawlability
              if (el.classList && el.tagName.toLowerCase() !== 'a') el.classList.add('kt-bad-src');
            }
          }
        }
        // inline style background url(undefined...)
        // CRITICAL: Skip hero sections - they should never have backgrounds removed
        var isHeroElement = el.closest && (
          el.closest('.t4s-hero-image, .kt-hero-enhanced, .t4s-hero, [class*="hero"], [data-hero], [data-hero-enhanced]') ||
          el.classList && (
            el.classList.contains('t4s-hero-inner') ||
            el.classList.contains('t4s-hero-block') ||
            el.classList.contains('kt-hero-enhanced__background') ||
            el.classList.contains('t4s-hero__background')
          )
        );
        
        if (!isHeroElement && el.getAttribute && el.hasAttribute('style')){
          var st = el.getAttribute('style') || '';
          if (/url\([^)]*undefined/i.test(st)){
            // remove any background URLs that include undefined
            try { el.style.backgroundImage = 'none'; } catch(e){}
            try { el.style.background = (st || '').replace(/url\([^)]*\)/gi, 'none'); } catch(e){}
            // also rewrite the style attribute to ensure removal
            var cleaned = (el.getAttribute('style') || '').replace(/url\([^)]*undefined[^)]*\)/gi, 'none');
            el.setAttribute('style', cleaned);
            // Don't add kt-bad-src to links - it breaks SEO crawlability
            if (el.classList && el.tagName.toLowerCase() !== 'a') el.classList.add('kt-bad-src');
          }
        }
      } catch(e){}
    };

    var scanAndSanitize = function(root){
      try {
        var scope = root && root.querySelectorAll ? root : document;
        // Target likely elements first for perf
        var nodes = scope.querySelectorAll('img,[data-bg],[data-src],[srcset],[src],a[href],[style*="url("]');
        for (var i=0;i<nodes.length;i++) purgeBadUrl(nodes[i]);
        // Also attempt targeted repair for carousel navs
        var navs = scope.querySelectorAll('.t4s-carousel__nav');
        for (var j=0;j<navs.length;j++) repairCarouselNav(navs[j]);
      } catch(e){}
    };

    // Intercept setAttribute and property sets (prevents new bad assignments)
    // Only intercept URL-related attributes to avoid interfering with third-party scripts
    var origSetAttribute = Element.prototype.setAttribute;
    Element.prototype.setAttribute = function(name, value){
      try {
        // Only check if element exists (don't block on null elements - let the original error happen)
        if (!this || this.nodeType !== 1) {
          return origSetAttribute.apply(this, arguments);
        }
        
        var n = String(name || '').toLowerCase();
        // Only block URL-related attributes with bad values
        if ((n === 'src' || n === 'srcset' || n === 'data-src' || n === 'data-bg' || n === 'href') && isBad(value)) {
          return; // skip invalid assignment
        }
        if (n === 'style' && /url\([^)]*undefined/i.test(String(value||''))){
          // scrub undefined background URLs from inline styles
          var cleaned = String(value||'').replace(/url\([^)]*undefined[^)]*\)/gi, 'none');
          return origSetAttribute.call(this, name, cleaned);
        }
      } catch(e) {
        // If our interceptor causes issues, let the original call proceed
        // This prevents breaking third-party scripts
      }
      return origSetAttribute.apply(this, arguments);
    };

    var imgSrc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (imgSrc && imgSrc.set) {
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        configurable: true,
        get: imgSrc.get,
        set: function(v){ if (!isBad(v)) imgSrc.set.call(this, v); }
      });
    }
    var imgSrcset = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'srcset');
    if (imgSrcset && imgSrcset.set) {
      Object.defineProperty(HTMLImageElement.prototype, 'srcset', {
        configurable: true,
        get: imgSrcset.get,
        set: function(v){ if (!isBad(v)) imgSrcset.set.call(this, v); }
      });
    }

    // Repair helpers for carousel nav thumbnails
    function getMainMediaContainer(start){
      var el = start;
      while (el && el !== document.documentElement){
        if (el.querySelector && (el.querySelector('[data-main-media]') || el.matches && (el.matches('[data-main-media]') || el.matches('[data-product-single-media-group]')))) return el;
        el = el.parentElement;
      }
      return document;
    }
    function findMatchingMainSlide(container, navItem){
      var gr = (navItem.getAttribute('data-grname')||'').toLowerCase();
      var gv = (navItem.getAttribute('data-grpvl')||'').toLowerCase();
      var scope = container.querySelector('[data-main-media]') || container;
      var selector = '';
      if (gr && gv){ selector = '[data-grname="'+CSS.escape(gr)+'"][data-grpvl="'+CSS.escape(gv)+'"]'; }
      var cand = selector ? scope.querySelector(selector) : null;
      if (!cand) cand = scope.querySelector('[data-main-slide]:not(.is--media-hide)');
      if (!cand) cand = scope.querySelector('[data-main-slide]');
      return cand;
    }
    function extractMasterImageUrl(slide){
      if (!slide) return '';
      var img = slide.querySelector('img[data-master]') || slide.querySelector('img[data-src]') || slide.querySelector('img[src]');
      var url = img ? (img.getAttribute('data-master') || img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
      return url || '';
    }
    function toLazyPath(u){
      try {
        var I = (window.T4SThemeSP && T4SThemeSP.Images) || null;
        if (I && typeof I.lazyloadImagePath === 'function') return I.lazyloadImagePath(u);
      } catch(e){}
      return u || '';
    }
    function applyThumb(navInner, url){
      if (!navInner) return;
      if (!url || isBad(url)) return;
      var lazy = toLazyPath(url);
      if (!lazy || isBad(lazy)) return;
      try { navInner.style.backgroundImage = 'url("'+lazy+'")'; } catch(e){}
      var img = navInner.querySelector('img');
      if (img){
        img.setAttribute('data-src', lazy);
        img.setAttribute('src', lazy);
        // Let lazysizes pick it up if present
        if (img.classList && !img.classList.contains('lazyloadt4s') && !img.classList.contains('lazyloadt4sed')){
          img.classList.add('lazyloadt4s');
        }
      }
    }
    function repairCarouselNav(nav){
      try {
        if (!nav) return;
        var items = nav.querySelectorAll('.t4s-carousel__nav-item');
        if (!items.length) return;
        var container = getMainMediaContainer(nav);
        for (var i=0;i<items.length;i++){
          var item = items[i];
          var inner = item.querySelector('.t4s-carousel__nav-inner');
          if (!inner) continue;
          var bg = inner.getAttribute('style') || '';
          var img = inner.querySelector('img');
          var src = (img && (img.getAttribute('data-src') || img.getAttribute('src'))) || '';
          var needsFix = /url\([^)]*undefined/i.test(bg) || isBad(src);
          if (!needsFix) continue;
          var slide = findMatchingMainSlide(container, item);
          var m = extractMasterImageUrl(slide);
          if (m && !isBad(m)) applyThumb(inner, m);
          else {
            // If totally missing, hide the broken nav item
            item.style.display = 'none';
          }
        }
      } catch(e){}
    }

    // Observe DOM for late-inserted content (innerHTML, variant changes, carousels)
    var mo;
    try {
      mo = new MutationObserver(function(mutations){
        for (var i=0;i<mutations.length;i++){
          var m = mutations[i];
          if (m.type === 'attributes') {
            purgeBadUrl(m.target);
            // If a carousel nav gets ready, try to repair
            if (m.attributeName === 'class' && m.target.classList && m.target.classList.contains('t4s-carousel__nav')){
              repairCarouselNav(m.target);
            }
          } else if (m.type === 'childList') {
            for (var j=0;j<m.addedNodes.length;j++){
              var node = m.addedNodes[j];
              if (node && node.nodeType === 1){
                scanAndSanitize(node);
                if (node.classList && node.classList.contains('t4s-carousel__nav')) repairCarouselNav(node);
              }
            }
          }
        }
      });
      // Ensure we observe a valid Node (fallback to body or documentElement)
      var targetNode = (document && document.documentElement) || document.body;
      if (targetNode && typeof targetNode.nodeType === 'number') {
        mo.observe(targetNode, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['src','srcset','data-src','data-bg','href','style','class']
        });
      }
    } catch(e){}

    // Simple fetch interceptor for undefined URLs - enhanced
    var originalFetch = window.fetch;
    if (originalFetch) {
      window.fetch = function(url, options) {
        // Check string URLs
        if (typeof url === 'string') {
          // Check for undefined product URLs first (most common)
          if (url.indexOf('/products/undefined') > -1 || 
              url.indexOf('undefined&width=') > -1 || 
              url.indexOf('undefined?width=') > -1 ||
              url.indexOf('/products/undefined&width=1') > -1) {
            console.warn('🔇 Blocked fetch request to undefined product URL:', url);
            return Promise.reject(new Error('Blocked undefined product URL'));
          }
          if (isBad(url)) {
            console.warn('🔇 Blocked fetch request to undefined URL:', url);
            return Promise.reject(new Error('Blocked undefined URL'));
          }
        }
        // Also check Request objects
        if (url && typeof url === 'object' && url.url) {
          var requestUrl = typeof url.url === 'string' ? url.url : String(url.url || '');
          // Check for undefined product URLs first
          if (requestUrl.indexOf('/products/undefined') > -1 || 
              requestUrl.indexOf('undefined&width=') > -1 ||
              requestUrl.indexOf('undefined?width=') > -1) {
            console.warn('🔇 Blocked fetch Request object with undefined product URL:', requestUrl);
            return Promise.reject(new Error('Blocked undefined product URL'));
          }
          if (isBad(requestUrl)) {
            console.warn('🔇 Blocked fetch Request object with undefined URL:', requestUrl);
            return Promise.reject(new Error('Blocked undefined URL'));
          }
        }
        return originalFetch.apply(this, arguments);
      };
    }

    // Also intercept XMLHttpRequest (some scripts use this instead of fetch)
    var originalXHROpen = XMLHttpRequest.prototype.open;
    if (originalXHROpen) {
      XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        if (typeof url === 'string' && isBad(url)) {
          console.warn('🔇 Blocked XMLHttpRequest to undefined URL:', url);
          // Prevent the request by throwing or setting a flag
          this._blocked = true;
          return;
        }
        return originalXHROpen.apply(this, arguments);
      };
      
      // Also intercept send to prevent blocked requests
      var originalSHRSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function(data) {
        if (this._blocked) {
          console.warn('🔇 Prevented send() on blocked XMLHttpRequest');
          return;
        }
        return originalSHRSend.apply(this, arguments);
      };
    }


    // Intercept at the lowest level - override the native Image constructor
    var originalImage = window.Image;
    window.Image = function() {
      var img = new originalImage();
      var originalSrc = '';
      
      Object.defineProperty(img, 'src', {
        get: function() { return originalSrc; },
        set: function(v) {
          if (isBad(v)) {
            console.warn('🔇 Blocked Image constructor src assignment to undefined URL:', v);
            originalSrc = '';
            return;
          }
          // Additional check for /products/undefined pattern
          if (typeof v === 'string' && (v.indexOf('/products/undefined') > -1 || v.indexOf('undefined&width=') > -1)) {
            console.warn('🔇 Blocked Image constructor src assignment to undefined product URL:', v);
            originalSrc = '';
            return;
          }
          originalSrc = v;
        },
        configurable: true
      });
      
      return img;
    };

    // Intercept image src assignments to prevent undefined URLs
    var originalImageSrc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (originalImageSrc && originalImageSrc.set) {
      Object.defineProperty(HTMLImageElement.prototype, 'src', {
        configurable: true,
        get: originalImageSrc.get,
        set: function(v) {
          if (isBad(v)) {
            console.warn('🔇 Blocked image src assignment to undefined URL:', v);
            return;
          }
          originalImageSrc.set.call(this, v);
        }
      });
    }

    // Intercept any script that might be constructing URLs with undefined handles
    var originalCreateElement = document.createElement;
    document.createElement = function(tagName) {
      var element = originalCreateElement.call(this, tagName);
      
      // If it's an img element, add protection
      if (tagName.toLowerCase() === 'img') {
        var originalSetAttribute = element.setAttribute;
        element.setAttribute = function(name, value) {
          // Only block URL-related attributes
          var attrName = String(name || '').toLowerCase();
          if ((attrName === 'src' || attrName === 'data-src' || attrName === 'data-bg') && isBad(value)) {
            console.warn('🔇 Blocked img attribute assignment to undefined URL:', name, value);
            return;
          }
          // Check for undefined product URLs specifically
          if ((attrName === 'src' || attrName === 'data-src') && typeof value === 'string' && 
              (value.indexOf('/products/undefined') > -1 || value.indexOf('undefined&width=') > -1)) {
            console.warn('🔇 Blocked img attribute assignment to undefined product URL:', name, value);
            return;
          }
          return originalSetAttribute.call(this, name, value);
        };
        
        // Also override the src property setter for this specific element
        var originalSrc = '';
        Object.defineProperty(element, 'src', {
          get: function() { return originalSrc; },
          set: function(v) {
            if (isBad(v)) {
              console.warn('🔇 Blocked img src property assignment to undefined URL:', v);
              return;
            }
            // Check for undefined product URLs specifically
            if (typeof v === 'string' && (v.indexOf('/products/undefined') > -1 || v.indexOf('undefined&width=') > -1)) {
              console.warn('🔇 Blocked img src property assignment to undefined product URL:', v);
              return;
            }
            originalSrc = v;
          },
          configurable: true
        });
      }
      
      return element;
    };

    // Intercept theme-hot-reload specific requests (development only)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      // Override any hot-reload image loading
      var originalImageLoad = HTMLImageElement.prototype.load;
      if (originalImageLoad) {
        HTMLImageElement.prototype.load = function() {
          if (this.src && isBad(this.src)) {
            console.warn('🔇 Blocked hot-reload image load to undefined URL:', this.src);
            return;
          }
          return originalImageLoad.call(this);
        };
      }
      
      // Intercept the actual network request by overriding the native image loading
      var originalAddEventListener = EventTarget.prototype.addEventListener;
      EventTarget.prototype.addEventListener = function(type, listener, options) {
        if (type === 'load' && this.tagName === 'IMG') {
          var wrappedListener = function(event) {
            if (this.src && isBad(this.src)) {
              console.warn('🔇 Blocked image load event for undefined URL:', this.src);
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
            return listener.call(this, event);
          };
          return originalAddEventListener.call(this, type, wrappedListener, options);
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    }


    // Initial pass for server-rendered or early client-rendered markup
    var runInitial = function(){ scanAndSanitize(document); };
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', runInitial, { once: true });
    } else {
      runInitial();
    }
  } catch(e) { /* no-op */ }
})();
